import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { TopNav } from "./TopNav";
import { UpgradePromptBanner } from "./UpgradePromptBanner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { useGroupStore } from "@/stores/groupStore";
import { useAuthStore } from "@/stores/authStore";

export function DashboardLayout() {
  const navigate = useNavigate();
  const fetchGroups = useGroupStore((s) => s.fetchGroups);
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    if (user?.emailVerifiedAt === null) {
      navigate("/verify-email", { replace: true });
      return;
    }
    fetchGroups();
  }, [user, fetchGroups, navigate]);

  return (
    <div className="min-h-screen w-full max-w-full bg-background overflow-x-hidden">
      <TopNav />
      <UpgradePromptBanner />
      <main className="container py-6">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
